import React from "react";
import './Settings.scss'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import RemainderEmail from "./RemainderEmail/RemainderEmail";
import TeamMembers from "./TeamMembers/TeamMembers";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useTeamInvitation from "../auth/useTeamInvitation";

import 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Settings() {
  const [activeTab, setActiveTab] = useState(0);
  useState(false);
  const { search } = useLocation();
  useTeamInvitation();
  useEffect(() => {
    if (new URLSearchParams(search).get('tab')) setActiveTab(1);
  }, [search]);
  return (
    <div className="settings-section">
      <div className="settings-content">Settings</div>
      <div className="settings-tab">
        <Tabs selectedIndex={activeTab} onSelect={(index) => setActiveTab(index)}>
          <TabList>
            <Tab>Reminder email</Tab>
            {/* <Tab>Team Members</Tab>  */}
          </TabList>
          <TabPanel>
            <RemainderEmail />
          </TabPanel>
          <TabPanel>
            <TeamMembers />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
}
export default Settings;
